import { components } from '../api-abcscale';
import { apiGet, apiPost, apiPut, apiDelete, ApiCallbacks } from '../apiClient';

type PermissionDto = components['schemas']['PermissionDto'];
type PagedResultOfPermissionDto = components['schemas']['PagedResultOfPermissionDto'];
type EntraUserDto = components['schemas']['EntraUserDto'];
type WeighedPermissionDto = components['schemas']['WeighedPermissionDto'];

const ADMIN_API_BASE = process.env.REACT_APP_ADMIN_API_BASE;

export type { PermissionDto, PagedResultOfPermissionDto, EntraUserDto, WeighedPermissionDto };

export async function getPermissions(
  page: number,
  pageSize: number,
  callbacks: ApiCallbacks<PagedResultOfPermissionDto>
): Promise<void> {
  await apiGet(
    `${ADMIN_API_BASE}/permissions?page=${page}&pageSize=${pageSize}`,
    callbacks,
    true
  );
}

export async function getPermissionById(
  id: number,
  callbacks: ApiCallbacks<PermissionDto>
): Promise<void> {
  await apiGet(
    `${ADMIN_API_BASE}/permissions/${id}`,
    callbacks,
    true
  );
}

export async function createPermission(
  dto: PermissionDto,
  callbacks: ApiCallbacks<PermissionDto>
): Promise<void> {
  await apiPost(
    `${ADMIN_API_BASE}/permissions`,
    dto,
    callbacks,
    true
  );
}

export async function updatePermission(
  id: number,
  dto: PermissionDto,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  await apiPut(
    `${ADMIN_API_BASE}/permissions/${id}`,
    dto,
    callbacks,
    true
  );
}

export async function deletePermission(
  id: number,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  await apiDelete(
    `${ADMIN_API_BASE}/permissions/${id}`,
    callbacks,
    true
  );
}

export async function getPermissionUsers(
  callbacks: ApiCallbacks<EntraUserDto[]>
): Promise<void> {
  await apiGet(
    `${ADMIN_API_BASE}/permissions/users`,
    callbacks,
    true
  );
}

export async function getUserPermissions(
  userEmail: string,
  resourceName: string,
  callbacks: ApiCallbacks<WeighedPermissionDto[]>
): Promise<void> {
  const params = new URLSearchParams({ userEmail, resourceName });
  await apiGet(
    `${ADMIN_API_BASE}/permissions/user?${params.toString()}`,
    callbacks,
    true
  );
}
